// extracted by mini-css-extract-plugin
module.exports = {"advertisers-page":"advertisers_advertisers-page__1xbK5","overflow-hidden-container":"advertisers_overflow-hidden-container__1Mm3L"};